import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';

export const getSbrConfig = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getSbrConfigRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/single-best-record/configuration',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getSbrConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(getSbrConfigFailure(err));
      });
  };
};

export const saveSbrConfig = (entityId, rules) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/single-best-record/configuration',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: rules,
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(saveSbrConfigSuccess(res.data));
        dispatch(getSbrConfig(entityId, sessionId));
      })
      .catch(err => {
        dispatch(saveSbrConfigFailure(err));
      });
  };
};

export const clearSbrConfigErrors = () => {
  return {
    type: Constants.SINGLEBESTRECORD_CLEAR_ERROR
  };
};

const getSbrConfigRequest = () => {
  return {
    type: Constants.SINGLEBESTRECORD_GET_REQUEST
  };
};

const getSbrConfigSuccess = data => {
  return {
    type: Constants.SINGLEBESTRECORD_GET_SUCCESS,
    payload: data
  };
};

const getSbrConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.SINGLEBESTRECORD_GET_FAILURE,
    payload
  };
};

const saveSbrConfigSuccess = data => {
  return {
    type: Constants.SINGLEBESTRECORD_SAVE_SUCCESS,
    payload: data
  };
};

const saveSbrConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.SINGLEBESTRECORD_SAVE_FAILURE,
    payload
  };
};
